"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Date = exports.DateConfig = exports.DateFieldType = void 0;
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const validators_1 = require("../../../validators");
exports.DateFieldType = "Date";
exports.DateConfig = t.exact(t.partial({
    label: validators_1.StringOrNull,
    placeholder: t.string,
    default: t.string,
}));
exports.Date = t.exact(t.intersection([
    t.type({
        type: t.literal(exports.DateFieldType),
    }),
    t.partial({
        fieldset: validators_1.StringOrNull,
        config: exports.DateConfig,
    }),
]));
